import { useEffect } from "react"

import { Analytics } from "./funnels"
import { EventDesc, EventMeta } from "./funnel-utils"

function EventMetaDoc({ data }: { data: EventMeta[] }) {
    return (
        <ul className="funnel_docs">
            {data.map((meta, i) => (
                <li key={(meta.id || i).toString() + i.toString()}>
                    {meta.ga_id || meta.id}s{meta.event_label ? " (label)" : null}
                    {meta.event_value ? " (value)" : null}: {meta.title}
                    {meta.format ? (
                        <small>
                            <br />
                            Формат: <pre className="d-inline">{meta.format}</pre>
                        </small>
                    ) : null}
                </li>
            ))}
        </ul>
    )
}

export function FunnelDocs() {
    useEffect(() => {
        // A quick and dirty fix for the layout
        // Our default styles mess things up tremendously
        for (const css of window.document.styleSheets) {
            css.disabled = true
        }
    }, [])
    const knownHitKeys = new Set([
        "id",
        "explanation",
        "nonInteraction",
        "title",
        "type",
        "fb",
        "funnel",
        "bind",
        "ga",
        "uriSuffix",
        "data",
        "defaultData",
    ] as Array<keyof EventDesc>)
    return (
        <div>
            <h2>Данные, которые отсылаются в системы аналитики</h2>
            {Object.values(Analytics)
                .map((eventSender) => eventSender.eventDesc)
                .map((eventDesc) => (
                    <div key={eventDesc.id}>
                        <h3>{eventDesc.title || eventDesc.id}</h3>
                        {/* TODO: display target analytics systems */}
                        {eventDesc.fb ? "(reported to GA & Facebook)" : null}
                        <ul className="funnel_docs">
                            <li>
                                {eventDesc.type === "pageview"
                                    ? ""
                                    : eventDesc.nonInteraction
                                      ? "nonInteraction"
                                      : "interaction"}{" "}
                                {eventDesc.type}
                                <strong>
                                    {eventDesc.type === "pageview" ? " /" : " "}
                                    {eventDesc.id}
                                </strong>
                                {eventDesc.data && <EventMetaDoc data={eventDesc.data} />}
                            </li>
                            {eventDesc.explanation ? (
                                <li>
                                    {eventDesc.explanation.map((s, i) => (
                                        <p key={i}>{s}</p>
                                    ))}
                                </li>
                            ) : null}
                            {Object.keys(eventDesc)
                                .filter((key) => !knownHitKeys.has(key as keyof EventDesc))
                                .map((key) => (
                                    <li key={key}>
                                        <strong>{key}</strong>:{" "}
                                        {eventDesc[key as keyof EventDesc]?.toString()}
                                    </li>
                                ))}
                        </ul>
                    </div>
                ))}
        </div>
    )
}
